import dayjs from "dayjs"
import { getKeyByValueOfJson, getValueByKeyOfJson } from "../Validator/FormValidations"
import AppFormData from "../JSON/AppFormData.json"
import { callMiddlewareAPI } from "../../Components/Common/CommonFunctions"
var Sha1 = require("sha-1")
window.RSha = Sha1

const customParseFormat = require("dayjs/plugin/customParseFormat")
dayjs.extend(customParseFormat)

const IP_URL: string = process.env.REACT_APP_IP_URL as string

const LEAD_URL: string = process.env.REACT_APP_LEAD_URL as string
const TRACER_URL: string = process.env.REACT_APP_TRACER_URL as string

const GROUP_EMP_URL = process.env.REACT_APP_GROUP_EMP_URL
const JWT_API_URL = process.env.REACT_APP_JWT_API_URL
const TOKEN_API_KEY = process.env.REACT_APP_TOKEN_API_KEY

const ipAPI = async () => {
  const reqParams = {
    method: "GET"
  }

  const response = await fetch(IP_URL, reqParams)
    .then((res) => res.json())
    .then((result) => {
      return result
    })
    .catch((error) => {
      return error
    })

  return response
}

const leadWSAPI = async (FormStore: any, Suit_LMS12: boolean | string) => {
  var MAIN_URL = window.location.href
  var URL_OBJ = new URL(MAIN_URL)
  var uidCode = URL_OBJ.searchParams.get("UID")
  let JwtToken = await window.UserSession["JwtToken"]

  var glbUid = uidCode ? uidCode : 39242
  window.Glb_UID = glbUid
  var formateDOB: any = dayjs(FormStore.calc_childDOB, "DD/MM/YYYY", true)
  formateDOB = formateDOB.isValid() ? formateDOB.format("YYYY-MM-DD") : ""
  // var PROD_CODE = FormStore.calc_planType === "Guaranteed" ? "E32" : "UW3"
  var LMS_pageName = FormStore.calc_planType === "Guaranteed" ? "savings:GIFT Calculator" : "ULIP:Signature Calculator"

  var LMS_column_12 = "YES"
  if (typeof Suit_LMS12 === "boolean") {
    LMS_column_12 = Suit_LMS12 ? "YES" : "NO"
  } else {
    LMS_column_12 = FormStore.calc_ndncCB ? "YES" : "NO"
  }
  var pageURL = new URL(window.location.href)
  let pathName = pageURL.pathname.split(".html")[0] + '.html'
  pathName = pageURL.origin + pathName

  var temp_obj: any = {
    // utm_campaign: pageURL.searchParams.get("utm_campaign") ?? "",
    // utm_keyword: pageURL.searchParams.get("utm_term") ?? "",
    // utm_adcontent: pageURL.searchParams.get("utm_content") ?? "",
    // utm_source: pageURL.searchParams.get("utm_source") ?? ""
    utm_campaign: pageURL.searchParams.get("utm_campaign") ?? "",
    utm_keyword: pageURL.searchParams.get("utm_term") ?? "",
    utm_adcontent: pageURL.searchParams.get("utm_content") ?? "",
    utm_source: pageURL.searchParams.get("utm_source") ?? "",
    lms_child_dob: formateDOB ?? "",
    lms_child_age: FormStore.calc_childAge ?? "",
    pod_prsn_occptn: FormStore.calc_occupation ?? "",
    pad_add_pin: FormStore.calc_pinCode,
    pad_add_city: FormStore.calc_city
  }
  //LmsAdditionalDetails: "{\"utm_campaign\":\"\",\"utm_keyword\":\"\",\"utm_adcontent\":\"\",\"utm_source\":\"\",\"lms_child_dob\":\"2020-09-29\",\"lms_child_age\":2}"

  temp_obj = JSON.stringify(temp_obj)
  console.log("check LeadWS temp_obj :", temp_obj)

  const bodyLeadWS = {
    LMS_uid: glbUid,
    // LMS_product_code: PROD_CODE,
    LMS_product_code: "SK",
    LMS_gender: FormStore.calc_childGender,
    LMS_dob: FormStore.calc_parentDOB,
    LMS_mobile: FormStore.calc_mobile,
    LMS_email: FormStore.calc_email,
    keyword: "",
    // LMS_TRAI_FLAG: FormStore.calc_ndncCB ? "YES" : "NO",
    LMS_TRAI_FLAG: "YES",
    matchtype: "",
    LMS_firstName: FormStore.calc_childName,
    LMS_lastName: "",
    LMS_tobacco: "",
    LMS_sumassured: 480000,
    // LMS_premium: "",
    // LMS_typeofplan: "",
    LMS_policyTerm: FormStore.calc_policyTerm,
    LMS_policypaymentfrequency: FormStore.calc_mode,
    // LMS_premiumterm: "",
    LMS_staff: "No",
    Lumpsum: "0",
    Monthly_income: "0",
    Term_critical_illness: "Self",
    LMS_pageName: "ulip-insurance-plans : child-education-planner",
    LMS_pageURL: pathName,
    LMS_session_id: "",
    LMS_column_1: "1",
    LMS_column_2: FormStore.calc_childName, //child name
    LMS_column_3: FormStore.calc_income, //annualincome
    LMS_column_4: "",
    LMS_column_5: "",
    LMS_column_6: "Self",
    LMS_column_7: glbUid + "", //uid
    LMS_column_8: "",
    LMS_column_9: "",
    LMS_column_10: "",
    LMS_column_11: "Yes",
    LMS_column_12: "Yes",
    LMS_premium: Math.round(FormStore.calc_savingValue), //step4 u start saving
    LMS_premiumterm: FormStore.calc_policyTerm, //policy term
    LmsAdditionalDetails: JSON.stringify(temp_obj)
  }

  // const bodySelector: any = bodyLeadWS
  // console.log(`LeadWS :`, bodySelector)
  // const bodyLeadWSObj = new URLSearchParams()
  // for (var i in bodyLeadWS) {
  //   bodyLeadWSObj.append(i, bodySelector[i])
  // }

  // const reqParams: any = {
  //   method: "POST",
  //   body: bodyLeadWSObj,
  //   credentials: "include",
  //   mode: "cors",
  //   headers: {
  //     "x-api-key": process.env.REACT_APP_LEAD_URL_X_API_KEY,
  //     "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
  //   }
  // }

  // console.info("lead params", reqParams)

  // const response = await fetch(LEAD_URL, reqParams)
  //   .then((res) => res.json())
  //   .then((result) => {
  //     console.info("Lead Return :", result)
  //     return result
  //   })
  //   .catch((error) => {
  //     console.info("Lead Error :", error)
  //     return error
  //   })

  // console.info("Lead Body :", body)
  // console.info("Lead Response :", response)
  const response = await callMiddlewareAPI("LEADWS", bodyLeadWS)
    .then((result: any) => {
      console.info("Lead Return :", result)
      return result
    })
    .catch((error: any) => {
      console.info("Lead Error :", error)
      return error
    })
  return response
}

const tracerAPI = async (FormStore: any, type: 1 | 2) => {
  var MAIN_URL = window.location.href
  var URL_OBJ = new URL(MAIN_URL)
  var uidCode = URL_OBJ.searchParams.get("UID")

  var glbUid = uidCode ? uidCode : 480
  window.Glb_UID = glbUid

  var dobVal = FormStore.calc_dob
  var IP_ADD = window.ipAddress
  var associationId = dobVal.split("/")[2] + FormStore.calc_mobile.slice(3)
  associationId = type === 1 ? associationId : associationId + "" + IP_ADD

  var PROD_CODE = FormStore.quote_prodCode

  const bodyTracerA = {
    message: "comition",
    properties: {
      amount: "0",
      gender: FormStore.calc_gender,
      cardType: "ICICI BANK",
      mobileNo: FormStore.calc_mobile,
      emailID: FormStore.calc_email,
      productCode: PROD_CODE,
      vendorUid: glbUid,
      associationId: associationId, // "19999999999", // "19999999999142.142.142.142"
      premium: "",
      message: "",
      deviceId: "19 Jun 1989",
      ipAddress: IP_ADD
    },
    source: process.env.REACT_APP_TRACER_URL_SOURCE
  }

  const reqParams: any = {
    method: "POST",
    body: JSON.stringify(bodyTracerA),
    credentials: "include",
    mode: "cors",
    headers: { "Content-Type": "application/json" }
  }

  const response = await callMiddlewareAPI("TRACER", reqParams)
    .then((result) => {
      // console.info("Tracer A Return :", result)
      return result
    })
    .catch((error) => {
      // console.info("Tracer A Error :", error)
      return error
    })

  // console.info("Tracer A Response :", response)
  return response
}

const groupEmpAPI = async (body: any) => {
  const response = await callMiddlewareAPI("EMP_DETAIL", body)
    .then((result) => {
      return result
    })
    .catch((error) => {
      return error
    })
  return response
}

const DataLayerFn = async (event: string, FormStore: any, question: string, buttonText: string, options: any, extraFlag: any) => {
  var CalcDOB: any = dayjs(FormStore.calc_dob, "DD/MM/YYYY", true)
  CalcDOB = CalcDOB.isValid() ? CalcDOB.format("MM/YY") : ""

  var quoteSeen = extraFlag["QuoteFlag"]
  var SuitabilityCalculation = extraFlag["SuitabilityCalculation"] ?? ""
  quoteSeen = quoteSeen === undefined ? FormStore.quote_modalLoader : !quoteSeen

  var eventName = event.split("||")[0]
  var sectionName = event.split("||")[1]

  const isAppFormDetails = window.UserDataJSON?.["appform-details"] ?? false
  const isCommuncation = window.UserDataJSON?.["Communication"] ?? false
  const education = isAppFormDetails ? await getValueByKeyOfJson(AppFormData["education"], isAppFormDetails["education"]) : ""
  const maritalStatus = isAppFormDetails ? await getValueByKeyOfJson(AppFormData["maritalStatus"], isAppFormDetails["mrtlSts"]) : ""
  const occupation = isAppFormDetails ? await getValueByKeyOfJson(AppFormData["occupation"], isAppFormDetails["occ"]) : ""
  const organizationType = isAppFormDetails ? await getValueByKeyOfJson(AppFormData["organization"], isAppFormDetails["orgType"]) : ""
  const state = isCommuncation ? await getKeyByValueOfJson(AppFormData["state"], isCommuncation["state"]) : ""

  var ApplicationNumber = await levelHandler("appNO", "")
  var OrganizationName = await levelHandler("appform-details", "orgNameDesc")
  var City = await levelHandler("Communication", "city")
  var NomineeRelationship = await levelHandler("Nominee", "relationship")
  var NomineeDOB = await levelHandler("Nominee", "nomineeDob")
  NomineeDOB = dayjs(NomineeDOB, "DD/MM/YYYY", true)
  NomineeDOB = NomineeDOB.isValid() ? NomineeDOB.format("MM/YY") : ""

  var ExistingCustomer = await levelHandler("ExistingCustomer", "")
  var GoalHorizon = await levelHandler("suitabilityMatrix", "goalHorizon")
  var InsurancePortfolioHeld = await levelHandler("suitabilityMatrix", "insurancePortfolioHeld")
  var RiskProfile = await levelHandler("suitabilityMatrix", "riskProfile")

  var isAppFormLoaded = window.isAppFormLoaded
  var tempLayer = {
    event: eventName,
    ProductCode: "",
    ProductName: "Child Education Planner",
    pageName: "savings:child-education-planner",
    pageType: "child-education-planner",
    subsection1: "",
    subsection2: "child-education-planner",
    channel: "savings",
    Subchannel: "child-education-planner",
    SectionName: sectionName,
    UID: window.Glb_UID,
    ADBRValue: "",
    Age: Math.sign(FormStore.calc_age) === 1 ? FormStore.calc_age : "",
    AnnualIncome: "",
    AnnuityAmount: "",
    AnnuityFrequency: "",
    Button: buttonText,
    CIValue: "",
    CancerCover: "",
    CarBrand: "",
    CarModel: "",
    CarVarient: "",
    City: "",
    CoveredAge: "",
    DOB: FormStore.calc_parentDOB,
    Device: window.innerWidth > 768 ? "Desktop" : "Mobile", // Desktop / Mobile
    Education: "",
    EstimatedReturnAt4: "",
    EstimatedReturnAt8: "",
    ExistingCustomer: "No",
    Gender: FormStore.calc_parentGender,
    GroupEmployee: "",
    GuaranteedReturn: "",
    GoalHorizon: "",
    InsurancePortfolioHeld: "",
    RiskProfile: "",
    OtherInsurancePolicy: "",
    HeartCover: "",
    HomeLoan: "",
    HospitalCashBenefit: "",
    IncomeBenefit: "",
    IncreasingCoverBenefit: "",
    InvestStyle: "",
    LifeCoverSelected: "",
    ApplicationNumber: "",
    MaritalStatus: "",
    MonthlyPremium: "",
    NPSSubscriber: "",
    NetworkUID1: quoteSeen ? "" : !FormStore.calc_mobile ? "" : eventName.includes("Email") ? "" : Sha1(FormStore.calc_mobile), // Mobile No Encrypted in SHA1
    NetworkUID2: quoteSeen ? "" : !FormStore.calc_email ? "" : eventName.includes("Mobile") ? "" : Sha1(FormStore.calc_email), // Email id Encrypted in SHA1
    NetworkUID3: "",
    NomineeDOB: "",
    Occupation: "",
    OptionSelected: options,
    OrganizationName: "",
    OrganizationType: "",
    OtherLoan: "",
    PaymentFrequency: "",
    PaymentTerm: "",
    PayoutOptionSelected: "",
    PolicyHolder: "",
    PolicyTerm: "",
    PolicyType: "",
    Premium: "",
    Question: question,
    Savings: "",
    State: "",
    NomineeRelationship: "",
    SuitabilityCalculation: SuitabilityCalculation,
    Tobacco: "",
    TypeOfOwnership: "",
    UserResponse: "",
    YearlyPremium: "",
    jointlifeDOB: "",
    jointlifeRelationship: "",
    nyPremium: "",
    retirement: ""
  }

  console.info("DataLayer", tempLayer)
  window.dataLayer.push(tempLayer)
  return ""
}

const levelHandler = async (lvl1: string, lvl2: string) => {
  try {
    if (lvl2 === "") return window.UserDataJSON[lvl1]
    else return window.UserDataJSON[lvl1][lvl2]
  } catch {
    return ""
  }
}

export { DataLayerFn, ipAPI, leadWSAPI, tracerAPI, groupEmpAPI }
